import { Component, OnInit } from '@angular/core';
import {GridOptions} from "ag-grid/main";
import { Router } from '@angular/router';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import { DataService, ServerConstantsService, AgGridUtility, VIEW_BTN, DOUBLE_ROW_HEADER } from '../shared';

@Component({
  selector: 'app-refferal-history',
  templateUrl: './refferal-history.component.html',
  styleUrls: ['./refferal-history.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class RefferalHistoryComponent implements OnInit {
  sharedData: any;
  wpPersonId: any;
  ServerConstants: any;
  userActionNotificationsMap: any;
  refferalHistory: any;
  columnDefs: any;
  context: any;
  gridOptions: GridOptions;
  gridApi: any;
  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER;

  constructor(
    private dataService: DataService,
    private router: Router,
    private http: HttpClient,
    private serverConstantsService: ServerConstantsService,
    private notificationService: NotificationsService,
    private agGridUtility: AgGridUtility
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('EMPPL') === undefined) {
      this.router.navigate(['/task']);
    }
    this.gridOptions = <GridOptions>{};
  }

  ngOnInit() {
    this.sharedData = this.dataService.getSharedDataObject();
    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.load();
    this.getColumnDefinitions();
  }

  load() {
    this.refferalHistory = [];
    this.http.post<any>(this.ServerConstants.COMMON_SERVER_API_URL + '/wp-et-enrollment/get-closed-et-enrollment-by-person', parseInt(this.wpPersonId)).subscribe((data) => {
      if (data.hasOwnProperty('errorCode')) {
        this.notificationService.error('Refferal History', this.userActionNotificationsMap.ERROR);
      }
      else {
        let value = [data];
        this.refferalHistory = data;
      }
    },
      response => {
        this.notificationService.error('Refferal History', this.userActionNotificationsMap.ERROR);
    },
      () => {
    });
  }

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Referral ID',
        field: "referral.id",
      },
      {
        headerName: 'Referral Date',
        field: "referral.ieReferralDt",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        }
      },
      {
        headerName: 'Enrollment Start Date',
        field: "enrollmentStartDt",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        }
      },
      {
        headerName: 'Enrollment End Date',
        field: "enrollmentEndDt",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        }
      },
      {
        headerName: 'Case Closuer Date',
        field: "enrollmentEndDt",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        }
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButton
      },
    ];

    this.context = {
      component: this,
    };
  }

  getUserInfoForRefeRRalHistory(referralId, wpPersonId) {
    this.dataService.addValueToSharedDataMap('referralId', referralId);
    this.dataService.addValueToSharedDataMap('wpPersonId', wpPersonId);
    this.http.post<any>(this.ServerConstants.COMMON_SERVER_API_URL + "/personsummary/personEnrollmentSummary",
      { "referralId": Number(referralId), "personId": Number(wpPersonId) })
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res === null || res === undefined) {
            this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
          } else {
            const personEnrollmentSummary: any = res;
            this.dataService.addValueToSharedDataMap("etEnrollment", personEnrollmentSummary.etEnrollment);
            if (personEnrollmentSummary.personProvider !== null) {
              this.dataService.addValueToSharedDataMap("personProvider", personEnrollmentSummary.personProvider);
            }
          }
        },
        response => {
          this.notificationService.error('Task Search', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }

  getEditButton(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    const image = VIEW_BTN;
    element.innerHTML = image;

    element.addEventListener('click', () => {
      that.getUserInfoForRefeRRalHistory(params.data.referral.id, params.data.person.id)
      that.dataService.allPagesReadOnly();
      that.router.navigate(['/task/personSummary/enrollmentSummary']);
    });
    element.addEventListener('keydown', (event) => {
      if (event.keyCode == 13 || event.keyCode == 32) {
        that.getUserInfoForRefeRRalHistory(params.data.referral.id, params.data.person.id)
        that.dataService.allPagesReadOnly();
        that.router.navigate(['/task/personSummary/enrollmentSummary']);
      }
    });
    element.setAttribute("tabindex", "0");
    return element;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else {
      this.gridOptions.api.sizeColumnsToFit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/refferal-history/refferal-history.component.ts